import React, { ReactNode } from "react";
import PiSettingsTile from "../../components/PiSettingsTile";
import "./ActorPresetEditorField.css";

type ActorPresetEditorFieldProps = {
  children: ReactNode;
  name: string;
  icon?: React.ElementType | null;
  className?: string;
  contentClassName?: string;
};

export default function ActorPresetEditorField(props: ActorPresetEditorFieldProps) {
  const { name, icon, children, className = "", contentClassName = "" } = props;

  return (
    <PiSettingsTile
      title={name}
      icon={icon}
      variant="divided"
      className={`actorpreseteditor-tile ${className}`.trim()}
      headerClassName="actorpreseteditor-tileheader"
      iconClassName="actorpreseteditor-tileicon text-creator-primary"
      titleClassName="actorpreseteditor-tiletitle"
      contentClassName={`actorpreseteditor-tilecontent ${contentClassName}`.trim()}
    >
      {children}
    </PiSettingsTile>
  );
}
